'use strict';

var store = require('adyen_config/store');
var constants = require('adyen_config/constants');
var commons = require('../commons/httpClient');
var httpClient = commons.httpClient;

function setOrderFormData(response) {
    if (response && response.orderNo && document.querySelector('#merchantReference')) {
        document.querySelector('#merchantReference').value = response.orderNo;
    }
    if (response && response.orderToken && document.querySelector('#orderToken')) {
        document.querySelector('#orderToken').value = response.orderToken;
    }
}

function handleComponentChanges(response, component) {
    if (response && response.fullResponse && response.fullResponse.action) {
        component.handleAction(response.fullResponse.action);
    } else if (response && response.skipSummaryPage) {
        document.querySelector('#result').value = JSON.stringify(response);
        document.querySelector('#showConfirmationForm').submit();
    } else if (response && (response.paymentError || response.error)) {
        component.handleError();
    }
}

/**
 * Makes an ajax call to the controller function PaymentFromComponent.
 * Used by certain payment methods like paypal
 * @param {Object} data - The payment data
 * @param {Object} component - The adyen component
 * @returns {Promise} - The promise object
 */
function paymentFromComponent(data, component) {
    var comp = component || {};
    var requestData = store.partialPaymentsOrderObj
        ? $.extend({}, data, {
            partialPaymentsOrder: store.partialPaymentsOrderObj
        })
        : data;

    return httpClient({
        url: window.paymentFromComponentURL,
        method: 'POST',
        data: {
            data: JSON.stringify(requestData)
        }
    }).then(function (response) {
        setOrderFormData(response);
        handleComponentChanges(response, comp);
        return response;
    });
}

function resetPaymentMethod() {
    $('#requiredBrandCode').hide();
    $('#selectedIssuer').val('');
    $('#adyenIssuerName').val('');
    $('#dateOfBirth').val('');
    $('#telephoneNumber').val('');
    $('#gender').val('');
    $('#bankAccountOwnerName').val('');
    $('#bankAccountNumber').val('');
    $('#bankLocationId').val('');
    $('.additionalFields').hide();
}

/**
 * Changes the "display" attribute of the selected method from hidden to visible
 * @param {string} type - The payment method type
 */
function displaySelectedMethod(type) {
    // If 'type' input field is present use this as type, otherwise default to function input param
    store.selectedMethod = document.querySelector('#component_' + type + ' .type')
        ? document.querySelector('#component_' + type + ' .type').value
        : type;
    resetPaymentMethod();

    var disabledSubmitButtonMethods = constants.DISABLED_SUBMIT_BUTTON_METHODS;
    if (window.klarnaWidgetEnabled) {
        disabledSubmitButtonMethods.push('klarna');
    }
    document.querySelector('button[value="submit-payment"]').disabled =
        disabledSubmitButtonMethods.findIndex(function (pm) {
            return type.indexOf(pm) > -1;
        }) > -1;

    document
        .querySelector('#component_' + type)
        .setAttribute('style', 'display:block');

    // set brand for giftcards if hidden inputfield is present
    var brandElement = document.querySelector('#component_' + type + ' .brand');
    store.brand = brandElement ? brandElement.value : null;
}

function displayValidationErrors() {
    if (store.selectedPayment && store.selectedPayment.node) {
        store.selectedPayment.node.showValidation();
    }
    return false;
}

var selectedMethods = {};

function doCustomValidation() {
    return store.selectedMethod in selectedMethods
        ? selectedMethods[store.selectedMethod]()
        : true;
}

function showValidation() {
    return store.selectedPaymentIsValid
        ? doCustomValidation()
        : displayValidationErrors();
}

function getInstallmentValues(maxValue) {
    var values = [];
    for (var i = 1; i <= maxValue; i += 1) {
        values.push(i);
    }
    return values;
}

function createShowConfirmationForm(action) {
    if (document.querySelector('#showConfirmationForm')) {
        return;
    }
    var template = document.createElement('div');
    template.innerHTML = '<form method="post" id="showConfirmationForm" name="showConfirmationForm" action="' + action + '">' +
        '<input type="hidden" id="additionalDetailsHidden" name="additionalDetailsHidden" value="null"/>' +
        '<input type="hidden" id="merchantReference" name="merchantReference"/>' +
        '<input type="hidden" id="orderToken" name="orderToken"/>' +
        '<input type="hidden" id="result" name="result" value="null"/>' +
        '<input type="hidden" id="redirectUrl" name="redirectUrl" value=""/>' +
        '</form>';
    document.querySelector('body').appendChild(template.firstChild);
}

function setExpressRedirectUrl() {
    var redirectUrlInput = document.querySelector('#redirectUrl');
    if (redirectUrlInput) {
        redirectUrlInput.value = window.location.pathname + window.location.search;
    }
}

module.exports = {
    setOrderFormData: setOrderFormData,
    paymentFromComponent: paymentFromComponent,
    resetPaymentMethod: resetPaymentMethod,
    displaySelectedMethod: displaySelectedMethod,
    showValidation: showValidation,
    createShowConfirmationForm: createShowConfirmationForm,
    getInstallmentValues: getInstallmentValues,
    setExpressRedirectUrl: setExpressRedirectUrl
};
